export default __webpack_public_path__ + "static/media/wallet.35d9f854.svg";